// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Trace extends APIResource {
    /**
     * Retrieve Trace For Step
     */
    retrieve(stepID, options) {
        return this._client.get(path `/v1/steps/${stepID}/trace`, options);
    }
}
//# sourceMappingURL=trace.mjs.map